"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceItem = void 0;
class ResourceItem {
    constructor(result) {
        this.result = result;
    }
    get title() {
        return this.getEntity('Title');
    }
    get priority() {
        return this.getEntity('priority');
    }
    get description() {
        return this.getEntity('description');
    }
    get omniTitle() {
        return this.getEntity('Omni_Title');
    }
    get omniDescription() {
        return this.getEntity('Omni_description');
    }
    get category() {
        return this.getEntity('Category');
    }
    get foundationalTopic() {
        return this.getEntity('foundational_topic');
    }
    get subTopic() {
        return this.getEntity('sub_topic');
    }
    get subTopicDetails() {
        return this.getEntity('sub_topic_details');
    }
    get heroImageUrl() {
        return this.getEntity('hero-image-3');
    }
    get subtopic() {
        return this.subTopic;
    }
    get imageUrl() {
        return this.heroImageUrl;
    }
    get text() {
        return this.result?.properties?.text?.join('\n') ?? '';
    }
    get url() {
        return this.result?.properties?.url ?? '';
    }
    getEntity(modelName) {
        return (this.result?.properties?.enriched_html?.entities?.find(e => e.model_name === modelName)?.text ?? '');
    }
}
exports.ResourceItem = ResourceItem;
